import { api as config } from '@api/utils/api-request';

export const API_HOST = `${process.env.WEBSITE_DOMAIN_URL}${
  process.env.ENV === 'local' ? `:${process.env.API_PORT}` : ''
}`;

export const api = config(API_HOST);
